"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormatDate = useFormatDate;
var _formatters = require("../formatters");
var _useCulture = require("./useCulture");
/**
 * Returns parameter `value` formatted according to selected date `format`.
 * The timezone information in the date value is optional. If the timezone information is missing, then it is expected to be the tenant timezone.
 * @see {@link formatDate} for more information.
 *
 * @param value Date value to format
 * @param format The type of output string format (e.g. full date time)
 * @param options Additional formatting options
 * @returns `value` formatted according to selected date `format`
 * @example
  // basic usage
  useFormatDate(new Date(), DateFormat.ShortDateTime);

  // use a custom pattern
  useFormatDate(new Date(), DateFormat.Custom, { customPattern: 'dd.MM.yyyy' });

  // enable transformation to the runtime (local) timezone
  useFormatDate(new Date(), DateFormat.ShortDateTime, { toLocalTimezone: true });
 */
function useFormatDate(value, format, options) {
  const {
    culture,
    timeZone
  } = (0, _useCulture.useCulture)();
  return (0, _formatters.formatDate)(value, format, culture, timeZone, options);
}
//# sourceMappingURL=useFormatDate.js.map